import React from 'react';
import PropTypes from 'prop-types';
import SubstitutionIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Substitution';
import SoccerBallIcon from '@pitchero/react-ui/dist/cjs/components/Icons/SoccerBall';
import CardIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Card';
import BootIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Boot';
import RugbyBallIcon from '@pitchero/react-ui/dist/cjs/components/Icons/RugbyBall';
import RugbyPostsIcon from '@pitchero/react-ui/dist/cjs/components/Icons/RugbyPosts';
import StarIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Star';
import RugbyPassIcon from '@pitchero/react-ui/dist/cjs/components/Icons/RugbyPass';
import NetballIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Netball';
import WhistleIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Whistle';
import NetIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Net';
import LacrosseSticksIcon from '@pitchero/react-ui/dist/cjs/components/Icons/LacrosseSticks';
import FootballIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Football';
import HockeySticksIcon from '@pitchero/react-ui/dist/cjs/components/Icons/HockeySticks';
import GloveIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Glove';
import IconWithTheme from '../icon-with-theme';

const nameToComponent = (name) => {
  switch (name) {
    case 'SUBSTITUTION':
      return SubstitutionIcon;
    case 'SOCCER_BALL':
      return SoccerBallIcon;
    case 'CARD':
      return CardIcon;
    case 'BOOT':
      return BootIcon;
    case 'RUGBY_BALL':
      return RugbyBallIcon;
    case 'RUGBY_POSTS':
      return RugbyPostsIcon;
    case 'STAR':
      return StarIcon;
    case 'RUGBY_PASS':
      return RugbyPassIcon;
    case 'NETBALL':
      return NetballIcon;
    case 'WHISTLE':
      return WhistleIcon;
    case 'NET':
      return NetIcon;
    case 'LACROSSE_STICKS':
      return LacrosseSticksIcon;
    case 'FOOTBALL':
      return FootballIcon;
    case 'HOCKEY_STICKS':
      return HockeySticksIcon;
    case 'GLOVE':
      return GloveIcon;
    default:
      return null;
  }
};

const MatchEventIcon = ({ color, name, fontColour, ...otherProps }) => {
  const Component = nameToComponent(name);
  return (
    Component && (
      <IconWithTheme>
        <Component
          color={fontColour}
          colorOne={color}
          colorTwo={fontColour}
          name={name}
          {...otherProps}
        />
      </IconWithTheme>
    )
  );
};

MatchEventIcon.defaultProps = {
  color: false,
};

MatchEventIcon.propTypes = {
  color: PropTypes.string,
  name: PropTypes.string.isRequired,
  fontColour: PropTypes.string.isRequired,
};

export default MatchEventIcon;
